module.exports = __webpack_public_path__ + "static/img/culture.27bb2c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture.png
// module id = WEng
// module chunks = 1